import React from 'react';
import styled from 'styled-components';
import { hexColorWithOpacity } from '../utilities/OTColors';
import { themeColor } from '../TWConstants.ts';
import usePlannerState from '../hooks/usePlannerState.ts';

const Wrapper = styled.div<{$width:number, $height:number}>`
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  margin: 10px 0 30px 0;
  font-family: Avenir, sans-serif;
  position: relative;
  overflow: hidden;
  border: 3px solid ${themeColor};
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: ${themeColor};
  margin-bottom: 10px;
`;

const NotesTextArea = styled.textarea`
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: Avenir, sans-serif;
  font-size: 14px;
  color: ${themeColor};
  resize: none;
  padding: 0;
  
  &::placeholder {
    color: ${hexColorWithOpacity(themeColor, 0.6)};
  }
`;

interface OTNotesProps {
  width?: number;
  height?: number;
}

function OTNotes({ width = 500, height = 260 }: OTNotesProps) {
  const { notes, setNotes } = usePlannerState();

  return (
    <Wrapper $width={width} $height={height}>
      <Title>Notes</Title>
      <NotesTextArea
        value={notes || ''}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Write your notes here..."
      />
    </Wrapper>
  );
}


export default OTNotes;
